module.exports = __webpack_public_path__ + "img/newDetail_zbhl1.cca96495.png";